@if (lesson && safePdfUrl) {
<div class="w-full h-full flex flex-col">
  <!-- Header do PDF -->
  <app-lesson-header
    icon="bi-file-pdf"
    iconColor="text-red-500"
    [title]="lesson.title"
    [subtitle]="lesson.description"
    [module]="module"
    [showModuleInfo]="true"
    additionalClasses="mt-1"
  >
  </app-lesson-header>

  <!-- Visualizador de PDF -->
  <div class="flex-1 min-h-0">
    <iframe
      class="w-full h-full block"
      [src]="safePdfUrl"
      [title]="lesson.title"
      frameborder="0"
      allow="fullscreen"
      loading="lazy"
    >
    </iframe>
  </div>
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-file-pdf text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">PDF não disponível</p>
  </div>
</div>
}
